import { Component, EventEmitter, Output } from '@angular/core';
import { MONTHS_OF_YEAR_LABELS } from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-unit-details-header-controls-month',
  templateUrl: './unit-details-header-controls-month.component.html',
  styleUrls: ['./unit-details-header-controls-month.component.scss'],
})
export class UnitDetailsHeaderControlsMonthComponent {
  @Output() month_change: EventEmitter<number> = new EventEmitter<number>();

  current_month: number = new Date().getMonth();

  onRightClick(): void {
    if (this.current_month < 11) {
      this.current_month++;
      this.month_change.emit(this.current_month);
    }
  }

  onLeftClick(): void {
    if (this.current_month > 0) {
      this.current_month--;
      this.month_change.emit(this.current_month);
    }
  }

  getMonthOfYearLabel(): string {
    return MONTHS_OF_YEAR_LABELS[this.current_month];
  }
}
